import { isNud } from '@/shared/utilities/typing'
import MappedEvaluationItemType from "@/shared/models/enums/mapped-evaluation-item-type";

/**
 * 実施ふり返りシート質問項目 エンティティ
 */
class PlannedWorksheetQuestion {
    planned_question_id;
    planned_worksheet_id;
    template_question_id;
    content;
    note;
    mapped_evaluation_item_type;
    question_type;
    priority;
    options;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.planned_question_id = properties.planned_question_id;

        this.planned_worksheet_id = properties.planned_worksheet_id;
        this.template_question_id = properties.template_question_id;
        this.content = properties.content;
        this.note = properties.note;
        this.mapped_evaluation_item_type = properties.mapped_evaluation_item_type;
        this.question_type = properties.question_type;
        this.priority = properties.priority;
        this.options = properties.options ?? [];
    }

    get mapped_evaluation_item_type_display () {
        return MappedEvaluationItemType.get(this.mapped_evaluation_item_type);
    }
}

export default PlannedWorksheetQuestion;
